import { render, staticRenderFns } from "./staff-role-details.vue?vue&type=template&id=0898e6a4&scoped=true&"
import script from "./staff-role-details.vue?vue&type=script&lang=js&"
export * from "./staff-role-details.vue?vue&type=script&lang=js&"
import style0 from "./staff-role-details.vue?vue&type=style&index=0&id=0898e6a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0898e6a4",
  null
  
)

export default component.exports